import { memo, useMemo } from "react";
import { NodeProps } from "reactflow";
import { NodeType } from "../../../models/nodeType";
import { useForm } from "react-hook-form";
import { FlowNodeWithChildren } from "./FlowNode";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import SelectAllegiance from "../../base/SelectAllegiance";
import { Allegiance } from "@worldwidewebb/quest-shared/dist/allegiance";

function ModifyPlayerAllegianceNode(props: NodeProps<NodeType<Allegiance>>) {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const allegianceId = nodeData?.allegianceId ?? "";

  const { getValues, setValue, handleSubmit } = useForm<Allegiance>({
    defaultValues: useMemo(
      () => ({
        allegianceId,
      }),
      [allegianceId]
    ),
    mode: "onChange",
  });

  const { updateNodeData } = useUpdateNodeData(nodeId);

  return (
    <FlowNodeWithChildren {...props}>
      <form
        className={"nodrag"}
        onSubmit={handleSubmit(updateNodeData)}
        onBlur={handleSubmit(updateNodeData)}
        onChange={handleSubmit(updateNodeData)}
      >
        <SelectAllegiance
          color={color}
          value={getValues("allegianceId")}
          setValue={(value) => setValue("allegianceId", value)}
        />
      </form>
    </FlowNodeWithChildren>
  );
}

export default memo(ModifyPlayerAllegianceNode);
